import {
	IonCol, IonContent, IonGrid, IonIcon, IonLabel, IonNote, IonRow, IonThumbnail, IonImg,
	IonSelect,
	IonSelectOption, IonList,
	IonItem,
	IonInput,
	IonFooter,
	IonPage,
	IonTitle,
	IonHeader,
	IonToolbar,
	useIonModal,
	IonButtons,
	IonButton,
	useIonLoading,
	useIonToast,
	IonSlide,
	IonSlides,
	useIonAlert,
	IonSearchbar,
	IonTextarea,
	IonCheckbox
} from '@ionic/react';
import {
	globeOutline, heartOutline, locationOutline, navigateOutline, phonePortraitOutline, closeOutline,
	idCardOutline, cameraOutline, information, pricetagOutline, mailOutline, desktopOutline, checkmark, alertSharp,
	saveOutline, cloudUploadOutline, 
	trashOutline
} from "ionicons/icons";
import { useState, useRef } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/css';
import '@ionic/react/css/ionic-swiper.css';

import { SwiperZoomModal } from '../components/SwiperZoomModal';

import { Camera, CameraResultType, CameraSource } from "@capacitor/camera";
import { defineCustomElements } from '@ionic/pwa-elements/loader';

import Resizer from 'react-image-file-resizer';

import axiosCall from '../data/axios';

import { locations } from '../data';
import { Capacitor } from '@capacitor/core';

export const AgentMarkerInfoWindow = ({ marker, onDismiss, setMyMarkersCheck, authValues, map }) => {

	defineCustomElements(window);

	const propertyTypes = [
		{
			id: 1,
			label: 'House',
			name: 'HOUSE',
		},
		{
			id: 2,
			label: 'Land',
			name: 'LAND',
		},
		{
			id: 3,
			label: 'Business',
			name: 'BUSINESS',
		}
	];

	const advertisementTypes = [
		{
			id: 1,
			name: 'FOR_SALE',
			label: 'For Sale'
		},
		{
			id: 2,
			name: 'FOR_RENT',
			label: 'For Rent'
		},
	];

	const publishStatuses = [
		{
			id: 1,
			name: true,
			label: "Published"
		},
		{
			id: 2,
			name: false,
			label: "Unpublished"
		}
	];

	const compareWith = (o1, o2) => {
		if (!o1 || !o2) {
			return o1 === o2;
		}

		if (Array.isArray(o2)) {
			return o2.some((o) => o.id === o1.id);
		}

		return o1 === o2;
	};

	const [presentAlert] = useIonAlert();

	const markerId = marker?.id;

	let mProperty = marker?.property_type; let mSale = marker?.sale_type;
	
	const [propertyType, setPropertyType] = useState(
		mProperty?.toLowerCase() == 'land' ? 'LAND' : (mProperty?.toLowerCase() == 'business' ? 'BUSINESS' : 'HOUSE')
	);

	const [adType, setAdType] = useState(
		mSale?.toLowerCase() == 'for rent' ? 'FOR_RENT' : 'FOR_SALE'
	);

	const [images, setImages] = useState(marker?.images ? marker.images : []);
	const [label, setLabel] = useState(marker?.title);
	const [info, setInfo] = useState(marker?.description);
	const [phone, setPhone] = useState(marker?.additional_contact_info ? marker.additional_contact_info : authValues?.user?.data?.user?.phone);
	const [email, setEmail] = useState( marker?.realtor_emails ? marker.realtor_emails : authValues?.user?.data?.user.email);
	const [showContact, setShowContact] = useState(true);
	const [location, setLocation] = useState(marker?.address);
	const [price, setPrice] = useState(marker?.price);
	const [specs, setSpecs] = useState(marker?.bedrooms);
	const [status, setStatus] = useState(marker?.is_published);
	const zoomModalDismiss = () => {
		dismissZoomModal();
	};
	const [clickedImageKey, setClickedImageKey] = useState(0);
	const [presentZoomModal, dismissZoomModal] = useIonModal(SwiperZoomModal, { zoomModalDismiss, images, clickedImageKey });
	function slideClick(imgKey) {
		setClickedImageKey(imgKey);
		presentZoomModal({
			initialBreakpoint: 1,
			breakpoints: [0, 1],
			backdropBreakpoint: 0,
			animated: true,
			swipToClose: true,
			cssClass: 'modal-fullscreen'
		});
	}
	/**
	 * upload to storage bucket, convert path to blob
	 * get file name from path
	 * 
	 * https://github.com/aaronksaunders/ionic-react-supabase-simple-storage
	 * 
	 * @param path
	 *
	const imageUploadReady = async (path) => {
		const response = await fetch(path);
		const blob = await response.blob();
		const filename = path.substr(path.lastIndexOf("/") + 1);
		setNewImages(existingNewImages => [...existingNewImages, blob]);
		return true;
	};
	/**
	* take picture using capacitor plugin
	*/
	const takePicture = async () => {

		try {
			const cameraResult = await Camera.getPhoto({
				quality: 100,
				//allowEditing: true,
				width: 500,
				resultType: CameraResultType.Uri,
				source: CameraSource.Prompt,
				promptLabelHeader: 'Choose Picture',
				promptLabelCancel: 'Cancel',
				promptLabelPhoto: 'From Photo Gallery',
				presentationStyle: 'fullscreen',
				webUseInput: true
			});

			const path = cameraResult?.webPath || cameraResult?.path;

			//setImagePath(path);

			setImages(prevImages => [...prevImages, { src: path}]);

			//await imageUploadReady(path);

			//setNewImages(existingNewImages => [...existingNewImages, path]);

			return true;

		} catch (e) {
			console.log(e);
		}
	};

	const handleFileChange = async (event) => {
		const files = event.target.files;
		const fileArray = Array.from(files);

		if (fileArray.length > 5) {
			alert(`Please upload a maximum of 5 images at a time.`);
			return;
		}

		const imagePromises = fileArray.map(async (file) => {
			if (!file.type.startsWith('image/')) {
				alert(`File ${file.name} is not an image.`);
				return null;
			}
			const reader = new FileReader();
			return new Promise((resolve) => {
				reader.onloadend = () => {
					resolve({ src: reader.result });
				};
				reader.readAsDataURL(file);
			});
		});

		const imageResults = await Promise.all(imagePromises);

		// Filter out any null results from non-image files
		const validImageResults = imageResults.filter(result => result !== null);

		// Only update the state if there are valid images
		if (validImageResults.length > 0) {
			setImages((prevImages) => [...prevImages, ...validImageResults]);
		}
	};

	const openFileDialog = () => {
		(document).getElementById("multi-image-upload").click();
	};

	const resizeFile = (file) =>
		new Promise((resolve) => {
			Resizer.imageFileResizer(
				file,
				720,
				720,
				"JPEG",
				100,
				0,
				(uri) => {
					resolve(uri);
				},
				"file"
			);
		});

	const [spinnerPresent, spinnerDismiss] = useIonLoading();
	const [presentToast] = useIonToast();

	const [formErrors, setFormErrors] = useState({});

	const validateForm = () => {
		const errors = {};
		if (!adType) errors.adType = 'Type is required';
		if (!label) errors.label = 'Title is required';
		if (!info) errors.info = 'Description is required';
		//if (!status) errors.status = 'Status of the items is required';
		if (!propertyType) errors.propertyType = 'Property Type is required';
		if (!price) errors.price = 'Price is required and should be a number';
		if (!location) errors.location = 'Location is required';
		if (!images || images.length < 1) images.images = 'Atleast one image is required';
		if (!email) errors.email = 'Email is required';
		if (!phone) errors.phone = 'Phone is required';
		if(phone && (!/^[+]*[0-9]*$/.test(phone) || phone.length < 8)) {
			errors.phone = 'Phone number is not valid.';
		}
		setFormErrors(errors);
		return Object.keys(errors).length === 0;
	};

	const handleSubmit = () => {
		if (validateForm()) {
			save();
		}
	};

	async function save() {

		let dt = new Date();

		let slug = marker?.slug;

		if(!slug) {
			slug = label.replace(/ /g, '-') + '_' + dt.getTime();
		}

		let emails = [];
		emails.push(email);

		let data = {
			"title": label,
			"slug": slug,
			"address": location,
			"city": location,
			"state": location,
			"latitude": marker?.lat,
			"longitude": marker?.lng,
			"zipcode": 11001,
			"description": info,
			"price": price,
			"realtor_names": authValues.user?.data?.user?.name,
			"realtor_emails": email,
			"additional_contact_info": phone,
			"show_names_emails": showContact ? 'True' : 'False',
			"bathrooms": 2,
			"bedrooms": 3,
			"sale_type": adType,
			"property_type": propertyType,
			"is_published": status
			/*,
			"main_photo": new File([newImages[0]], slug+'_main_photo.'+newImages[0]?.type.split('/')[1], {'lastModifiedDate': new Date(), 'type': newImages[0]?.type}),
			"photo_1": new File([newImages[1]], slug+'_photo_1.'+newImages[1]?.type.split('/')[1], {'lastModifiedDate': new Date(), 'type': newImages[1]?.type}),
			"photo_2": new File([newImages[2]], slug+'_photo_2.'+newImages[2]?.type.split('/')[1], {'lastModifiedDate': new Date(), 'type': newImages[2]?.type}),
			"photo_3": new File([newImages[3]], slug+'_photo_3.'+newImages[3]?.type.split('/')[1], {'lastModifiedDate': new Date(), 'type': newImages[3]?.type})
			*/
		};

		spinnerPresent({
			message: 'Saving. Please wait...',
			spinner: 'bubbles',
			animated: true,
			cssClass: 'drukre-loading'
		});

		let formData = new FormData();

		Object.entries(data).map(([key, value]) => {
			formData.append(key, value);
		});

		for (const img of images) {
			/**
			 * Fetches from both local for new images and from public folder on backend server
			 * To be able to fetch from backend server, this had to be done on .htaccess in public folder
			 * Header always set Access-Control-Allow-Origin "*"
			 * Might have to move the image storage to some other location in the backend.
			 * Also need to delete existing image from the file location.
			 */
			const response = await fetch(img.src);
			const blob = await response.blob();
			let imgFile = new File([blob], slug +'_'+ Math.random() + '.' + blob?.type.split('/')[1], { 'lastModifiedDate': new Date(), 'type': blob?.type });
			let resizedImg = await resizeFile(imgFile);

			/*
			let base64Img = await new Promise((resolve) => {
				const reader = new FileReader();
				reader.onloadend = () => {
					resolve(reader.result);
				};
				reader.readAsDataURL(resizedImg);
			});

			formData.append("photo", base64Img);
			*/
			if(Capacitor.isNativePlatform()) 
				formData.append('photo', blob)
			else
				formData.append("photo", resizedImg);
			formData.append("caption", 'Caption for ' + slug + '_' + Math.random());
			//formData.append("photos[]", { photo: resizedImg, caption: 'Caption for ' + slug + '_' + Math.random() });
		}

		for (var pair of formData.entries()) {
			console.log(pair[0] + ', ' + pair[1]);
		}

		if(markerId) {
			formData.append('id', markerId);
		}
			
		axiosCall("/api/listing/manage", markerId ? "put" : "post", formData, true, 'multipart/form-data')
		.then((res) => {
			setMyMarkersCheck(false);
			setTimeout(() => {
				spinnerDismiss();
			}, 2000);
			presentToast({
				message: `Listing ${markerId ? 'Updated' : 'Created'} Successfully!`,
				icon: checkmark,
				color: 'success',
				buttons: [
					{
						text: 'Dismiss',
						role: 'cancel'
					}
				]
			  });
			onDismiss();
		})
		.catch((error) => {
			//setMessage("Auth failure! Please create an account");
			//setIserror(true);
			setTimeout(() => {
				spinnerDismiss();
			}, 2000);
			presentToast({
				message: error.message,
				icon: alertSharp,
				color: 'danger',
				buttons: [
					{
						text: 'Dismiss',
						role: 'cancel'
					}
				]
			  });
		});
	}

	function deleteImage(e, imgKey) {

		let updatedImages = images.filter((item, i) => imgKey !== i);

		//const slides = document.querySelectorAll('ion-slide');

		if (updatedImages.length > 0) {
		
			setImages(updatedImages);

		} else {

			presentToast({
				message: 'Keep atleast one image',
				icon: alertSharp,
				color: 'danger',
				buttons: [
					{
						text: 'Dismiss',
						role: 'cancel'
					}
				]
			  });

		}
		
	}

	async function deleteAd(confirm=false) {

		if(!marker.id) {
			await map.removeMarker(marker.markerId);
			onDismiss();
		} else {

			spinnerPresent({
				message: 'Deleting. Please wait...',
				spinner: 'bubbles',
				animated: true,
				cssClass: 'drukre-loading'
			});

			axiosCall("/api/listing/manage", "delete", {slug: marker.slug}, true, 'multipart/form-data')
			.then((res) => {
				setMyMarkersCheck(false);
				spinnerDismiss();
				presentToast({
					message: 'Listing Deleted Successfully!',
					icon: checkmark,
					color: 'success',
					buttons: [
						{
							text: 'Dismiss',
							role: 'cancel'
						}
					]
				});
				onDismiss();
				map.removeMarker(marker.markerId);
			})
			.catch((error) => {
				//setMessage("Auth failure! Please create an account");
				//setIserror(true);
				spinnerDismiss();
				presentToast({
					message: error.message,
					icon: alertSharp,
					color: 'danger',
					buttons: [
						{
							text: 'Dismiss',
							role: 'cancel'
						}
					]
				});
			});
		}
	}

	let [locationResults, setLocationResults] = useState([]);
	
	const handleLocationInput = (ev) => {
		setLocation(''); 
		setLocationResults([]); 
		let query = '';
		const target = ev.target;
		if (target) query = target.value.toLowerCase();
		
		if(!query) return;
		Object.entries(locations).filter(([dzongkhag, gewogs]) => {
			gewogs.filter((gewog) =>{
				if(gewog.toLowerCase().indexOf(query) > -1 || dzongkhag.toLowerCase().indexOf(query) > -1) {
					setLocationResults(prev => [...prev, gewog+' - ' +dzongkhag]);
				}
			});
		});
	};
	
	const locationListClick = (ev, gew) => {
		setLocation(gew);
		setLocationResults([]);
	};

	// Add this function to validate input
	const validateSimpleTextInput = (input) => {
		// Allow only letters, numbers, hyphens and spaces
		const regex = /^[a-zA-Z0-9\- ]*$/;
		return regex.test(input);
	};

	const handleTitleChange = (e) => {
		// Remove any characters that aren't letters, numbers, hyphens or spaces
		const sanitizedValue = e.target.value.replace(/[^a-zA-Z0-9\- ]/g, '');
		setLabel(sanitizedValue);
	};

	return (
		<IonPage>
			<IonHeader>
				<IonToolbar>
					<IonRow>
						<IonCol size="9">
							<IonTitle>Enter Property Info</IonTitle>
						</IonCol>
						<IonCol size="3" className="ion-float-end">
							<IonIcon className="ion-float-right" icon={closeOutline} onClick={() => onDismiss()} />
						</IonCol>
					</IonRow>
				</IonToolbar>
			</IonHeader>
			<IonContent>
				<IonGrid className="ion-padding">
					<IonRow>
						<IonCol size='12'>
							<IonList>
								<IonItem>
									<IonSelect
										label="Advertisement Type"
										interface="popover"
										placeholder="Select Advertisement Type"
										compareWith={compareWith}
										value={adType} onIonChange={(e) => setAdType(e.target.value)}>
										{advertisementTypes.map((type) => (
											<IonSelectOption key={type.name} value={type.name}>
												{type.label}
											</IonSelectOption>
										))}
									</IonSelect>
								</IonItem>
							</IonList>
							{formErrors.adType && <p className="error-message">{formErrors.adType}</p>}
						</IonCol>
					</IonRow>

					<IonRow>
						<IonCol size='12'>
							<IonList>
								<IonItem>
									<IonSelect
										label="Property Type"
										interface="popover"
										placeholder="Select Propert Type"
										compareWith={compareWith}
										value={propertyType} onIonChange={(e) => setPropertyType(e.target.value)}>
										{propertyTypes.map((type) => (
											<IonSelectOption key={type.name} value={type.name} >
												{type.label}
											</IonSelectOption>
										))}
									</IonSelect>
								</IonItem>
							</IonList>
							{formErrors.propertyType && <p className="error-message">{formErrors.propertyType}</p>}
						</IonCol>
					</IonRow>

					<IonRow>
						<IonCol>
							<Swiper slidesPerView={5} initialSlide={2} speed={400} spaceBetween={10} centeredSlides={true}
								zoom={true} key={images.map(slide => slide.id).join('_')}>
								{images.map((image, i) => {
									if(!image.src.includes('undefined')) { 
									 	return <SwiperSlide key={i}>
												<div className="swiper-zoom-container">
													<IonIcon className="img-delete" icon={closeOutline} onClick={(e) => deleteImage(e, i)}/>
													<IonImg src={image.src} onClick={() => slideClick(i)}/>
												</div>
											</SwiperSlide>
									}
								}
								)}
							</Swiper>
							{formErrors.images && <p className="error-message">{formErrors.images}</p>}
						</IonCol>
					</IonRow>

					<IonRow>
						<IonCol>
							<IonButton fill="outline" color="drukre" onClick={takePicture}>
								<IonIcon icon={cameraOutline} /> &nbsp; Take Picture
							</IonButton>
						</IonCol>
						<IonCol className="ion-text-end">
							<div style={{ position: 'relative', display: 'inline-block' }}>
								<input
									type="file"
									multiple
									onChange={handleFileChange}
									id="multi-image-upload"
									style={{
										position: 'absolute',
										left: 0,
										top: 0,
										opacity: 0,
										width: '100%',
										height: '100%',
										cursor: 'pointer',
									}}
								/>
								<IonButton fill="outline" color="drukre" onClick={openFileDialog}>
									<IonIcon icon={cloudUploadOutline}></IonIcon> &nbsp; Upload Multiple
								</IonButton>
							</div>
						</IonCol>
					</IonRow>

					<IonRow className="ion-margin-bottom">
						<IonCol size="12">
							<IonItem>
								<IonIcon icon={globeOutline} color="drukre" />
								<IonInput label="Title" value={label} onIonChange={handleTitleChange}></IonInput>
							</IonItem>
							{formErrors.label && <p className="error-message">{formErrors.label}</p>}
						</IonCol>
					</IonRow>

					<IonRow className="ion-margin-bottom">
						<IonCol size="12">
							<IonItem>
								<IonIcon icon={information} color="drukre" />
								<IonTextarea label="Description" labelPlacement="floating" placeholder="Enter Description" 
									value={info} onIonChange={(e) => setInfo(e.target.value)}
									counter={true}
									maxlength={5000}
									autoGrow={true}
									counterFormatter={(inputLength, maxLength) => `${maxLength - inputLength} characters remaining`}		  
								></IonTextarea>
							</IonItem>
							{formErrors.info && <p className="error-message">{formErrors.info}</p>}
						</IonCol>
					</IonRow>

					<IonRow className="ion-justify-content-start ion-align-items-center">
						<IonCol size="12">
							<IonItem>
								<IonIcon icon={idCardOutline} color="drukre" />
								<IonInput label="Phone" value={phone} onIonChange={(e) => setPhone(e.target.value)}></IonInput>
							</IonItem>
							{formErrors.phone && <p className="error-message">{formErrors.phone}</p>}
						</IonCol>
					</IonRow>

					<IonRow className="ion-justify-content-start ion-align-items-center">
						<IonCol size="12">
							<IonItem>
								<IonIcon icon={mailOutline} color="drukre" />
								<IonInput label="Email" value={email} onIonChange={(e) => setEmail(e.target.value)}></IonInput>
							</IonItem>
							{formErrors.email && <p className="error-message">{formErrors.email}</p>}
						</IonCol>
					</IonRow>

					<IonRow className="ion-justify-content-start ion-align-items-center">
						<IonCol size="12">
							<IonItem>
								<IonCheckbox labelPlacement="end" value={showContact} checked={showContact} onIonChange={(e) => setShowContact(e.target.checked)}>
									<IonLabel>Do you want customers to see your contact info?</IonLabel>
								</IonCheckbox>
							</IonItem>
						</IonCol>
					</IonRow>

					<IonRow className="ion-margin-bottom">
						<IonCol size="12">
							{/*
							<IonItem>
								<IonIcon icon={locationOutline} color="drukre" />
								<IonInput label="Location" value={location} onIonChange={e => setLocation(e.target.value)}></IonInput>
							</IonItem>
							*/}
							<IonItem>
								<IonIcon icon={locationOutline} color="drukre" />
								<IonSearchbar onClearInput={(e) => setLocationResults([])} debounce={1000} label="Location" value={location} placeholder="Enter Location" name="location" onIonInput={(ev) =>handleLocationInput(ev)}>
								</IonSearchbar>
							</IonItem>
							<IonList>
								{Object.entries(locationResults).map(([dzo, gew]) => (
									<IonItem key={gew} onClick={(ev) => locationListClick(ev, gew)}>{gew}</IonItem>
								))}
							</IonList>
							{formErrors.location && <p className="error-message">{formErrors.location}</p>}
						</IonCol>
					</IonRow>

					<IonRow className="ion-justify-content-start ion-align-items-center">
						<IonCol size="12">
							<IonItem>
								<IonIcon icon={pricetagOutline} color="drukre" />
								<IonInput label="Nu." type="number" value={price} onIonChange={(e) => setPrice(e.target.value)}></IonInput>
								
							</IonItem>
							{formErrors.price && <p className="error-message">{formErrors.price}</p>}
						</IonCol>
					</IonRow>

					<IonRow>
						<IonCol size='12'>
							<IonList>
								<IonItem>
									<IonSelect
										label="Status"
										interface="popover"
										placeholder="Would you like to publish it?"
										compareWith={compareWith}
										value={status} onIonChange={(e) => setStatus(e.target.value)}>
										{publishStatuses.map((type) => (
											<IonSelectOption key={type.name} value={type.name}>
												{type.label}
											</IonSelectOption>
										))}
									</IonSelect>
								</IonItem>
							</IonList>
							{formErrors.status && <p className="error-message">{formErrors.status}</p>}
						</IonCol>
					</IonRow>

					{/*
					<IonRow className="ion-justify-content-start ion-align-items-center">
						<IonCol size="12">
							<IonItem>
								<IonIcon icon={desktopOutline} color="drukre" style={{ fontSize: "1.5rem" }} />
								<IonInput label="Specifications" value={specs} onIonChange={(e) => setSpecs(e.target.value)}></IonInput>
							</IonItem>
						</IonCol>
					</IonRow>
					*/}
				</IonGrid>
			</IonContent>
			<IonFooter>
				<IonRow>
					<IonCol size="12" className="ion-text-end">
						<IonButton fill="outline" color="danger" 
							onClick={() =>
								presentAlert({
								  header: 'Are you sure you want to proceed',
								  subHeader: '',
								  message: 'Once you delete, you won\'t be able to retrieve it.',
								  buttons: [
									{
										text: 'Cancel',
										role: 'cancel',
									  },
									  {
										text: 'Confirm',
										role: 'confirm',
										handler: () => {
										  deleteAd(true);
										},
									  }
								  ],
								})
							  }
						>
							<IonIcon icon={trashOutline} />&nbsp;
							Delete Property
						</IonButton>
						<IonButton color="drukre" onClick={() => handleSubmit()}>
							<IonIcon icon={saveOutline} />&nbsp;
							Save
						</IonButton>
					</IonCol>
				</IonRow>
			</IonFooter>
		</IonPage>
	);
}